import { render } from "./ClientDeleteSecretModal.vue?vue&type=template&id=6eff3706"
import script from "./ClientDeleteSecretModal.vue?vue&type=script&lang=js"
export * from "./ClientDeleteSecretModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__